"use client";

import React from "react";
import { WandSparkles } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function MeetThePartyLady() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="meet-the-party-lady" ref={sectionRef} className="relative w-full overflow-hidden bg-transparent">
      <div className="grid min-h-[600px] w-full grid-cols-1 lg:grid-cols-2">
        {}
        <div className={cn("relative h-[500px] w-full lg:h-auto", "transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10")}>
          <div className="absolute inset-0 flex items-center justify-center overflow-hidden lg:pr-12">
            {}
            <div className="relative h-full w-full overflow-hidden bg-muted lg:rounded-br-[10rem] lg:rounded-tr-[4rem]">
              <img src="https://loved-mayfly.10web.cloud/wp-content/uploads/2026/03/Katie.jpg" alt="Katie the Party Lady" className="h-full w-full object-cover object-top" />
              {}
              <div className="absolute inset-0 bg-primary/5 mix-blend-overlay" />
            </div>
          </div>
        </div>

        {}
        <div className={cn("flex flex-col justify-center px-6 pt-28 pb-16 lg:px-16 lg:pt-40 lg:pb-24 text-lg", "transition-all delay-300 duration-1000 ease-out", isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10")}>
          <div className="max-w-xl space-y-6">
            <h2 className="text-4xl leading-tight text-primary !text-center !font-bold md:text-5xl lg:text-6xl">Meet <br />Katie the Party Lady</h2>
            
            <div className="space-y-4 text-lg leading-relaxed text-primary">
              <p className="!text-xl">Katie “The Party Lady” is the founder of Abracadabra Events and has been planning parties and weddings for over 15 years. She’s passionate about turning everyday gatherings into creative, joy-filled experiences that feel magical from start to finish—without the stress.</p>
              <p className="!text-xl">Known for her imagination, organization, and signature flair, Katie brings personalized events directly to homes, businesses, and venues throughout the community. From high-energy children’s celebrations to interactive adult experiences and polished corporate gatherings, she designs events that are fun, memorable, and thoughtfully executed.</p>
              <p className="!text-xl">Proudly serving Contra Costa County and the greater East Bay Area, Katie brings the magic to you—so you can relax and enjoy every moment.</p>
            </div>

            {}
            <div className="flex items-center gap-3 pt-4">
              <span className="h-px w-12 bg-secondary/50"></span>
              <WandSparkles className="h-8 w-8 text-secondary rotate-12 animate-pulse" />
              <span className="h-px w-12 bg-secondary/50"></span>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-30">
        <div className="absolute top-10 right-10 h-2 w-2 rounded-full bg-secondary blur-[1px] snow" />
        <div className="absolute bottom-20 left-1/2 h-1.5 w-1.5 rounded-full bg-secondary blur-[1px] snow" />
        <div className="absolute top-1/3 right-1/4 h-1 w-1 rounded-full bg-secondary blur-[1px] snow" />
      </div>
    </section>;
}